@include host-component-properties;

:host {
  --paf-toggle-checkbox-label-color: var(--paf-global-post-brand-secondary);
  --paf-toggle-checkbox-label-color-active: var(--paf-global-post-brand-black);
  --paf-toggle-checkbox-label-font-size: 16;
  --paf-toggle-checkbox-label-padding: 16;
  --paf-toggle-checkbox-background-color: var(--paf-global-post-brand-gray-20);
  --paf-toggle-checkbox-background-color-active: var(--paf-global-post-success);
  --paf-toggle-checkbox-background-border-width: var(--paf-global-border-width-2x);
  --paf-toggle-checkbox-background-border-color: var(--paf-global-post-brand-secondary);
  --paf-toggle-checkbox-background-border-color-active: var(--paf-global-post-success);
  --paf-toggle-checkbox-handle-background-color: var(--paf-global-post-brand-white);
  --paf-toggle-checkbox-handle-border-width: var(--paf-global-border-width-2x);
  --paf-toggle-checkbox-handle-border-color: var(--paf-global-post-brand-black);
  --paf-toggle-checkbox-width: 64;
  --paf-toggle-checkbox-height: 32;
  --paf-toggle-checkbox-handle-dimensions: 28;
  --paf-toggle-checkbox-transition-duration: 180ms;
}

.wrapper {
  @include reset-fieldset;

  display: flex;
  align-items: center;

  .label {
    order: 1;
    position: relative;
    display: flex;
    align-items: center;
    font-size: px-to-rem(var(--paf-toggle-checkbox-label-font-size));
    cursor: pointer;
    user-select: none;
    color: var(--paf-toggle-checkbox-label-color);
    -webkit-tap-highlight-color: transparent;
    transition: color var(--paf-toggle-checkbox-transition-duration);
    box-sizing: border-box;
    min-height: px-to-rem(var(--paf-toggle-checkbox-height));
    padding-inline-end:
      px-to-rem(
        calc(
          var(--paf-toggle-checkbox-label-padding) + var(--paf-toggle-checkbox-width)
        )
      );

    @include reduced-motion {
      transition: none;
    }
  }

  .input {
    order: 2;
    position: relative;
    appearance: none;
    outline: none;
    flex-shrink: 0;
    margin: 0 px-to-rem(calc(var(--paf-toggle-checkbox-width) - 2 * var(--paf-toggle-checkbox-background-border-width))) 0 px-to-rem(calc(-1 * var(--paf-toggle-checkbox-width)));
    padding: 0;
    flex-basis: px-to-rem(var(--paf-toggle-checkbox-width));
    height: px-to-rem(var(--paf-toggle-checkbox-height));
    background-color: var(--paf-toggle-checkbox-background-color);
    border-radius: px-to-rem(var(--paf-toggle-checkbox-height));
    border-width: px-to-rem(var(--paf-toggle-checkbox-background-border-width));
    border-style: solid;
    border-color: var(--paf-toggle-checkbox-background-border-color);
    pointer-events: none;
    transition-duration: var(--paf-toggle-checkbox-transition-duration);
    transition-property: background-color, border-color;

    @include reduced-motion {
      transition: none;
    }

    &:after {
      content: "";
      position: absolute;
      inset-block-start: 0;
      inset-inline-start: 0;
      background: var(--paf-toggle-checkbox-handle-background-color);
      width: px-to-rem(var(--paf-toggle-checkbox-handle-dimensions));
      height: px-to-rem(var(--paf-toggle-checkbox-handle-dimensions));
      border-radius: 50%;
      border-width: px-to-rem(var(--paf-toggle-checkbox-handle-border-width));
      border-style: solid;
      border-color: var(--paf-toggle-checkbox-handle-border-color);
      transition-duration: var(--paf-toggle-checkbox-transition-duration);
      transition-property: inset-inline-start;

      @include reduced-motion {
        transition: none;
      }
    }

    &:checked {
      border-color: var(--paf-toggle-checkbox-background-border-color-active);
      background-color: var(--paf-toggle-checkbox-background-color-active);

      ~ .label {
        color: var(--paf-toggle-checkbox-label-color-active);

        @include forced-colors {
          color: ActiveText;
        }
      }
    }

    &:checked:after {
      $widthDiff: calc(var(--paf-toggle-checkbox-width) - var(--paf-toggle-checkbox-handle-dimensions));
      $bordersSum: calc(
        var(--paf-toggle-checkbox-handle-border-width) + var(--paf-toggle-checkbox-background-border-width)
      );

      inset-inline-start: px-to-rem(calc($widthDiff - $bordersSum));

      @include forced-colors {
        background-color: ActiveText;
      }
    }

    &:focus-visible {
      @include focus-visible;

      border-radius: px-to-rem(var(--paf-toggle-checkbox-height));
    }
  }
}
